export const FULLSCREEN = 'fullscreen';
export const THUMBNAIL  = 'thumbnail';
export const NORMAL     = 'normal';


// WEBPACK FOOTER //
// ./src/Enum/ViewModes.js